import { MessageHead } from './MessageHead.response';

export class MessageHeadEntity extends MessageHead {
	public static tryCast(o: any): MessageHeadEntity {
		const ret = new MessageHeadEntity();
		return Object.assign(ret, o);
	}
}
